import React from 'react';
import { Text } from 'components/service';
import * as yup from 'yup';
import * as hoursUtils from 'components/form/elements/Hours/utils';
import * as translations from 'constants/translations';
import { RESTAURANT_ORDER_PICKUP_TYPE } from 'constants/restaurant';

export const initialValues = {
  titleEn: '',
  titleAr: '',
  addressEn: '',
  addressAr: '',
  buildingNumber: '',
  street: '',
  cityId: '',
  block: '',
  areaEn: '',
  deliveryNotes: '',
  forceScheduledThreshold: 360,
  contactNumber: '',
  openingHours: hoursUtils.generateInitialValue('24:00', '12:00'),
  pickupOrdersEnabled: false,
  pickupOrdersType: RESTAURANT_ORDER_PICKUP_TYPE.STORE_PICKUP,
  deliveryOrdersEnabled: false,
  beachOrderEnabled: false,
  dineIn: false,
  isPOSRequired: false,
  posBranchId: '',
  courierBranchId: '',
};

export const validationSchema = {
  titleEn: yup.string().required(<Text value={translations.TITLE_EN_IS_REQ} />),
  titleAr: yup.string().required(<Text value={translations.TITLE_AR_IS_REQ} />),
  addressEn: yup.string().required(<Text value={translations.ADDRESS_IN_ENGLISH_IS_REQ} />),
  addressAr: yup.string().required(<Text value={translations.ADDRESS_IN_ARABIC_IS_REQ} />),
  buildingNumber: yup.string().required(<Text value={translations.BUILDING_NUMBER_IS_REQ} />),
  street: yup.string().required(<Text value={translations.STREET_NAME_IS_REQ} />),
  cityId: yup.string().required(<Text value={translations.CITY_IS_REQ} />),
  block: yup.string().required(<Text value={translations.BLOCK_IS_REQUIRED} />),
  deliveryNotes: yup.string().nullable(),
  contactNumber: yup
    .string()
    .required(<Text value={translations.PHONE_IS_REQ} />)
    .matches(new RegExp('^[+|00]?[0-9]{1,19}$'), <Text value={translations.PHONE_IS_INVALID} />)
    .nullable(),
  courierBranchId: yup
    .array()
    .nullable()
    .when('isCourier', {
      is: true,
      then: yup.string().nullable(),
    }),
  posBranchId: yup
    .string()
    .nullable()
    .when('isPOSRequired', {
      is: true,
      then: yup
        .string()
        .nullable()
        .required(<Text value={translations.FOODICS_BRANCH_LINKING_DESCRIPTION} />),
    })
    .when('isOcims', {
      is: true,
      then: yup
        .string()
        .nullable()
        .required(<Text value={translations.EXTERNAL_ID_IS_REQUIRED} />),
    }),
};

export const wrapperSchema = defaultLocation =>
  yup.object().shape({
    ...validationSchema,
    location: yup.mixed().test('is-default_location', <Text value={translations.LOCATION_IS_REQ} />, location => {
      let isDefaultLocation = false;
      if (location.lat !== parseFloat(defaultLocation.lat) && location.lng !== parseFloat(defaultLocation.lng)) {
        isDefaultLocation = true;
      }
      return isDefaultLocation;
    }),
  });
